import React from "react";
import { Flex } from "@chakra-ui/react";
import { useColorTheme } from "contexts/color-theme";
import { SubNavLink } from "./sub-nav-link";
import { type PlatformTeaserProps } from "./data";
import { NavColumnLabel } from "./nav-column-label";

export function PlatformTeaser({ label, items }: PlatformTeaserProps) {
  const { theme, bgColor } = useColorTheme();
  return (
    <Flex
      borderRadius="big"
      bg={bgColor === "white" ? "brand.backgroundSecondary.light" : `brand.header.backgroundSecondary.${theme}`}
      direction="column"
      h="100%"
      px={{ base: "smaller", xl: "smaller" }}
      py={{ base: "smaller", lg: "big" }}
      mr={{ base: "smaller", xl: 0 }}
      ml={{ base: "smaller", lg: 0 }}
    >
      <NavColumnLabel mt={{ base: "smaller", lg: 0 }}>{label}</NavColumnLabel>

      <Flex direction="column" align="start" w="100%">
        {items.map((navItem) => (
          <SubNavLink key={navItem.label} aria-label={navItem.label} bgVariant="secondary" {...navItem} />
        ))}
      </Flex>
    </Flex>
  );
}
